import { axiosPost } from "./Axios";

export const createPaymentIntentApi = async (data: any) => {
  try {
    const response = await axiosPost<
      any,
      IPaymentIntentApiResponse
    >(
      "/orderCream/createPaymentIntent", // Replace with your login endpoint
      data
    );
    return response; // Return the user data
  } catch (error) {
    throw error;
  }
};
